var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{ref:"atable",attrs:{"bordered":"","row-selection":{ selectedRowKeys: _vm.selectedRowKeys, onChange: _vm.onChange },"columns":_vm.columns,"dataSource":_vm.dataSource,"pagination":false,"scroll":{ x: 1000 }}})}
var staticRenderFns = []

export { render, staticRenderFns }